var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 22.5H3C2.59 22.5 2.25 22.16 2.25 21.75C2.25 21.34 2.59 21 3 21H21C21.41 21 21.75 21.34 21.75 21.75C21.75 22.16 21.41 22.5 21 22.5Z",
    fill: "#909090"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.02 3.97991C17.08 2.03991 15.18 1.98991 13.19 3.97991L11.98 5.18991C11.88 5.28991 11.84 5.44991 11.88 5.58991C12.64 8.23991 14.76 10.3599 17.41 11.1199C17.45 11.1299 17.49 11.1399 17.53 11.1399C17.64 11.1399 17.74 11.0999 17.82 11.0199L19.02 9.80991C20.01 8.82991 20.49 7.87991 20.49 6.91991C20.5 5.92991 20.02 4.96991 19.02 3.97991Z",
    fill: "#909090"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.61 12.03C15.32 11.89 15.04 11.75 14.77 11.59C14.55 11.46 14.34 11.32 14.13 11.17C13.96 11.06 13.76 10.9 13.57 10.74C13.55 10.73 13.48 10.67 13.4 10.59C13.07 10.31 12.7 9.95005 12.37 9.55005C12.34 9.53005 12.29 9.46005 12.22 9.37005C12.12 9.25005 11.95 9.05005 11.8 8.82005C11.68 8.67005 11.54 8.45005 11.41 8.23005C11.25 7.96005 11.11 7.69005 10.97 7.41005C10.9488 7.36465 10.9283 7.31949 10.9084 7.27458C10.7608 6.94127 10.3262 6.84382 10.0684 7.10158L4.33995 12.83C4.20995 12.96 4.08995 13.21 4.05995 13.38L3.51995 17.21C3.41995 17.89 3.60995 18.53 4.02995 18.96C4.38995 19.31 4.88995 19.5 5.42995 19.5C5.54995 19.5 5.66995 19.49 5.78995 19.47L9.62995 18.93C9.80995 18.9 10.06 18.78 10.18 18.65L15.9013 12.9287C16.1608 12.6692 16.0629 12.2237 15.7253 12.0797C15.6873 12.0634 15.6489 12.0469 15.61 12.03Z",
    fill: "#909090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.521e3c087642264fd357347a7dfa60f5.svg";
export { ForwardRef as ReactComponent };